import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import asyncComponent from "../components/AsyncComponent";
import NavBar from '../components/navbar';
import LoginPage from '../containers/LoginPage';
import Loader from '../components/loader';
import Snackbar from 'material-ui/Snackbar';
import base64 from 'base-64';
import utf8 from 'utf8';
import '../css/App.css';
import '../css/loader.css';
import { MuiThemeProvider, createMuiTheme } from 'material-ui/styles';
import CssBaseline from 'material-ui/CssBaseline';

import * as sessionActions from 'actions/session';

const AsyncLandingPage = asyncComponent(() => import("../containers/LandingPage"));
const AsyncListingImagesPage = asyncComponent(() => import("../components/listingimages"));
const AsyncListingDetailPage = asyncComponent(() => import("../containers/ListingDetailPage"));

const theme = createMuiTheme({
	palette: {
		primary: {
			main: '#B90C3C'
		},
	},
});

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {
			showFooter: true,
			showHeader: true,
			showLoader: false
		};
		this.onShowHideHeader = this.onShowHideHeader.bind(this);
		this.onShowHideFooter = this.onShowHideFooter.bind(this);
	}

	onShowHideHeader(flag) {
		this.setState({ showHeader: flag });
	}

	onShowHideFooter(flag) {
		this.setState({ showFooter: flag });
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.isFetching !== nextProps.isFetching ||
			this.props.isLCFetching !== nextProps.isLCFetching ||
			this.props.isVCFetching !== nextProps.isVCFetching ||
			this.props.isVLFetching !== nextProps.isVLFetching ||
			this.props.isLIFetching !== nextProps.isLIFetching ||
			this.props.isLDFetching !== nextProps.isLDFetching ||
			this.props.isFHAKFetching !== nextProps.isFHAKFetching ||
			this.props.isCLFetching !== nextProps.isCLFetching ||
			this.props.isNANFetching !== nextProps.isNANFetching ||
			this.props.isMRVTWiseFetching !== nextProps.isMRVTWiseFetching ||
			this.props.isFRVTWiseFetching !== nextProps.isFRVTWiseFetching ||
			this.props.isARTotalFetching !== nextProps.isARTotalFetching) {
			
			if(nextProps.isFetching === true || nextProps.isLCFetching === true ||
				nextProps.isVCFetching === true || nextProps.isVLFetching === true || 
				nextProps.isLIFetching === true || nextProps.isLDFetching === true || 
				nextProps.isFHAKFetching === true || nextProps.isCLFetching === true || 
				nextProps.isNANFetching === true || nextProps.isMRVTWiseFetching === true ||
				nextProps.isFRVTWiseFetching === true || nextProps.isARTotalFetching === true){
				this.setState({ showLoader: true });
			}
			else{
				this.setState({ showLoader: false });
			}			
		}
	}

	render() {

		const { session } = this.props;

		var header = null;
		if (this.state.showHeader) {
			header = (
				<NavBar {...this.props} />
			);
		}

		var footer = null;
		if (this.state.showFooter) {
			footer = (
				<div></div>
			)
		}

		return (
			<MuiThemeProvider theme={theme}>
				<div className="App">
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.showLoader}
						SnackbarContentProps={{
							'aria-describedby': 'lmessage-id'
						}}
						message={
							<div id="lmessage-id" style={{width: "200px", textAlign: "center"}}>
								<Loader color="#fff" textColor="#fff" text="Loading..." />
							</div>
						}
					/>
					<CssBaseline />
					<Router>
						<div>
							{header}	

							<Route path="/login" render={(props) =>
								<LoginPage
									onShowHideFooter={this.onShowHideFooter}
									showFooter={this.state.showFooter}
									onShowHideHeader={this.onShowHideHeader}
									showHeader={this.state.showHeader}
									{...props} />
							}
							/>

							<PrivateRoute
								exact={true}
								path="/"
								session={session}
								onShowHideFooter={this.onShowHideFooter}
								showFooter={this.state.showFooter}
								onShowHideHeader={this.onShowHideHeader}
								showHeader={this.state.showHeader}
								component={AsyncLandingPage} />

							<PrivateRoute
								path="/home/:activeTab?"
								session={session}
								onShowHideFooter={this.onShowHideFooter}
								showFooter={this.state.showFooter}
								onShowHideHeader={this.onShowHideHeader}
								showHeader={this.state.showHeader}
								component={AsyncLandingPage} />

							<PrivateRoute
								exact={true}
								path="/listingimages"
								session={session}
								onShowHideFooter={this.onShowHideFooter}
								showFooter={this.state.showFooter}
								onShowHideHeader={this.onShowHideHeader}
								showHeader={this.state.showHeader}
								component={AsyncListingImagesPage} />

							<PrivateRoute
								path="/listingdetail/:mlsNumber"
								session={session}
								onShowHideFooter={this.onShowHideFooter}
								showFooter={this.state.showFooter}
								onShowHideHeader={this.onShowHideHeader}
								showHeader={this.state.showHeader}
								component={AsyncListingDetailPage} />

						</div>
					</Router>
					{footer}
				</div>
			</MuiThemeProvider>
		);
	}
}

const mapStateToProps = (state, props) => {

	return {
		session: state.session,
		isFetching: state.listings.isFetching,
		isLCFetching: state.listings.isLCFetching,
		isVCFetching: state.listings.isVCFetching,
		isVLFetching: state.listings.isVLFetching,
		isLIFetching: state.listings.isLIFetching,
		isLDFetching: state.listings.isLDFetching,
		isFHAKFetching: state.listings.isFHAKFetching,
		isCLFetching: state.listings.isCLFetching,
		isNANFetching: state.listings.isNANFetching,
		isMRVTWiseFetching: state.reports.isMRVTWiseFetching,
		isFRVTWiseFetching: state.reports.isFRVTWiseFetching,
		isARTotalFetching: state.reports.isARTotalFetching,
	}
};

const mapDispatchToProps = dispatch => ({
	sessionActions: bindActionCreators(sessionActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

// Redirect to the component only if the user is logged in, otherwise send to login page
const PrivateRoute = ({ component: Component, session, ...rest }) => (
	<Route {...rest} render={props => {

		const { isAuthenticating, isAuthenticated } = session;

		if (isAuthenticated === false && isAuthenticating === false) {

			if(props.location && props.location.pathname && props.location.pathname !== '/'){
                window.sessionStorage.setItem("RedirectLocation",base64.encode(utf8.encode(props.location.pathname)));
			}
			
			return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />;
		}

		if(isAuthenticated === true && window.sessionStorage.getItem("RedirectLocation")){                
            const redirectUrl = utf8.decode(base64.decode(window.sessionStorage.getItem("RedirectLocation")));
            window.sessionStorage.removeItem("RedirectLocation");
            return <Redirect to={{pathname: redirectUrl, state: {from: props.location}}}/>;
		}
		
		return <Component {...props} {...rest} />;

	}} />
)